import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserStampsCollectionRequest } from '@/shared/model/user-stamps-collection-request.model';

const baseApiUrl = 'api/user-stamps-collection-requests';
const baseSearchApiUrl = 'api/_search/user-stamps-collection-requests?query=';

export default class UserStampsCollectionRequestService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserStampsCollectionRequest> {
    return new Promise<IUserStampsCollectionRequest>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserStampsCollectionRequest): Promise<IUserStampsCollectionRequest> {
    return new Promise<IUserStampsCollectionRequest>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserStampsCollectionRequest): Promise<IUserStampsCollectionRequest> {
    return new Promise<IUserStampsCollectionRequest>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
